import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import "./plan.css";

function Plan() {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [plans, setPlans] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const paymentOptions = [
    { title: "वार्षिक राशिफल रिपोर्ट", price: 199 },
    { title: "Matchmaking (कुंडली मिलान )", price: 199 },
    { title: "प्रश्न कुंडली (Prashna Kundali)", price: 199 },
    { title: "रत्न परामर्श (Gemstone Suggestion)", price: 199 },
    { title: "दोष निवारण परामर्श", price: 199 },
    {
      title:
        "विवाह , गृह प्रवेश /निर्माण , वाहन क्रय , आदि कोई भी विशेष मुहूर्त जानकारी",
      price: 199,
    },
    { title: "विस्तृत 180+ Page सम्पूर्ण जन्म कुंडली Pdf", price: 399 },
    { title: "सम्पूर्ण विस्तृत वास्तु दोष निरीक्षण व समाधान", price: 1100 },
  ];

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const isOptionalPlan =
    selectedPlan && String(selectedPlan.price).toLowerCase() === "optional";

  const requireLogin = (callback) => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

    if (!isLoggedIn) {
      navigate("/login", { state: { from: location } });
      return;
    }

    callback();
  };

  const handlePayClick = (plan) => {
    setSelectedPlan(plan);
    setSelectedOption(null);
    setShowModal(true);
  };

  const handleClose = () => {
    if (loading) return;

    setShowModal(false);
    setSelectedPlan(null);
    setSelectedOption(null);
    setForm({
      name: "",
      email: "",
      phone: "",
    });
    setLoading(false);
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const validateForm = () => {
    if (isOptionalPlan && !selectedOption) {
      alert("Please select payment option");
      return false;
    }

    if (!form.name.trim()) {
      alert("Please enter your name");
      return false;
    }

    if (!form.email.trim()) {
      alert("Please enter your email");
      return false;
    }

    if (!form.phone.trim()) {
      alert("Please enter your phone number");
      return false;
    }

    if (!/^\d{10}$/.test(form.phone.trim())) {
      alert("Please enter valid 10 digit phone number");
      return false;
    }

    return true;
  };

  const handlePayment = async () => {
    try {
      if (!selectedPlan) {
        alert("Please select a plan");
        return;
      }

      if (!validateForm()) return;

      if (!window.Razorpay) {
        alert("Razorpay SDK not loaded. Please add Razorpay script in index.html");
        return;
      }

      const amount = isOptionalPlan
        ? Number(selectedOption.price)
        : Number(selectedPlan.price);

      const paymentTitle = isOptionalPlan
        ? selectedOption.title
        : selectedPlan.title;

      if (!amount || amount <= 0) {
        alert("Invalid amount");
        return;
      }

      setLoading(true);

      const res = await fetch(
        "https://dashboard.jyotirvani.com/api/generate-token",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            amount: amount,
            payment_type: "plan",

            plan_id: selectedPlan.id,
            plan_name: paymentTitle,

            name: form.name.trim(),
            email: form.email.trim(),
            phone: form.phone.trim(),
          }),
        }
      );

      const data = await res.json();

      console.log("PAYMENT RESPONSE:", data);

      if (!res.ok || data.status === false) {
        alert(data.message || "Payment creation failed");
        setLoading(false);
        return;
      }

      const razorpay = new window.Razorpay({
        key: data.key,
        amount: data.amount,
        currency: data.currency || "INR",
        name: "JyotirVani",
        description: paymentTitle,
        order_id: data.order_id,

        handler: async function (response) {
          try {
            const verifyRes = await fetch(
              "https://dashboard.jyotirvani.com/api/verify-razorpay-payment",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                body: JSON.stringify({
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_signature: response.razorpay_signature,
                  local_order_id: data.local_order_id,
                  return_type: "plan",
                }),
              }
            );

            const verifyData = await verifyRes.json();

            if (verifyData.status) {
              const user = JSON.parse(localStorage.getItem("user") || "null");

              const historyKey = user?.email
                ? `payment_history_${user.email}`
                : "payment_history_guest";

              const oldHistory =
                JSON.parse(localStorage.getItem(historyKey)) || [];

              const newHistory = {
                order_id: data.local_order_id,
                type: "plan",
                title: paymentTitle || "Plan Payment",
                amount: amount,
                payment_status: "success",
                payment_mode: "Razorpay",
                date: new Date().toISOString(),
              };

              localStorage.setItem(
                historyKey,
                JSON.stringify([newHistory, ...oldHistory])
              );

              alert("Payment successful");
              handleClose();
            } else {
              alert(verifyData.message || "Payment verification failed");
              setLoading(false);
            }
          } catch (error) {
            console.error("Verify Error:", error);
            alert("Payment verification failed");
            setLoading(false);
          }
        },

        prefill: {
          name: form.name.trim(),
          email: form.email.trim(),
          contact: form.phone.trim(),
        },

        notes: {
          local_order_id: data.local_order_id,
          plan_id: selectedPlan.id,
          plan_name: paymentTitle,
        },

        theme: {
          color: "#7c3aed",
        },

        modal: {
          ondismiss: function () {
            setLoading(false);
          },
        },
      });

      razorpay.open();
    } catch (error) {
      console.error("Payment Error:", error);
      alert("Payment failed");
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await fetch(
          "https://dashboard.jyotirvani.com/api/fetchplan"
        );

        const result = await response.json();

        if (result.status && result.data) {
          const formattedPlans = result.data.map((plan) => ({
            id: plan.id,
            title: plan.title,
            price: plan.price,
            description: plan.type,
            included: plan.plandetails
              ? plan.plandetails.map((item) => item.plandesc)
              : [],
            tag: plan.type === "basic" ? "Popular" : null,
            buttonColor: "#ff5722",
            buttonTextColor: "#fff",
          }));

          setPlans(formattedPlans);
        }
      } catch (error) {
        console.error("Error fetching plans:", error);
      }
    };

    fetchPlans();
  }, []);

  return (
    <div className="plan-section container">
      <h2 className="plans-title">
        Choose Your <span>Plan</span>
      </h2>

      <p className="plans-subtitle">
        Choose the Subscription That Suits You Best
      </p>

      <section className="plans-container">
        {plans.map((plan, index) => {
          const isNext = hoveredIndex === index - 1;

          return (
            <div
              key={plan.id || index}
              className={`plan-card ${plan.tag ? "highlighted" : ""} ${
                isNext ? "hover-next" : ""
              }`}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className="plan-header">
                <span className="plan-type">{plan.description}</span>

                {plan.tag && <span className="plan-tag">{plan.tag}</span>}
              </div>

              <h2 className="plan-price">₹{plan.price}</h2>

              <p className="plan-description">{plan.title}</p>

              <div className="plan-includes">
                {plan.included.map((item, i) => (
                  <p key={i}>
                    <FaCheckCircle className="check-icon" /> {item}
                  </p>
                ))}
              </div>

              <button
                className="get-started-btn"
                style={{
                  backgroundColor: plan.buttonColor,
                  color: plan.buttonTextColor,
                }}
                onClick={() => requireLogin(() => handlePayClick(plan))}
              >
                Pay Now
              </button>
            </div>
          );
        })}
      </section>

      {showModal && selectedPlan && (
        <div className="ra-plan-qr-modal-overlay">
          <div className="ra-plan-qr-modal-content">
            <h3>Enter Your Details</h3>

            {isOptionalPlan && (
              <select
                value={selectedOption ? selectedOption.title : ""}
                onChange={(e) => {
                  const option = paymentOptions.find(
                    (item) => item.title === e.target.value
                  );
                  setSelectedOption(option);
                }}
                disabled={loading}
                style={{
                  width: "100%",
                  padding: "12px",
                  marginBottom: "12px",
                  borderRadius: "8px",
                  border: "1px solid #ddd",
                  fontWeight: "600",
                }}
              >
                <option value="">Select Payment Option</option>
                {paymentOptions.map((option, index) => (
                  <option key={index} value={option.title}>
                    {option.title} - ₹{option.price}
                  </option>
                ))}
              </select>
            )}

            <input
              type="text"
              name="name"
              placeholder="Enter Name"
              value={form.name}
              onChange={handleChange}
              disabled={loading}
            />

            <input
              type="email"
              name="email"
              placeholder="Enter Email"
              value={form.email}
              onChange={handleChange}
              disabled={loading}
            />

            <input
              type="tel"
              name="phone"
              placeholder="Enter Phone"
              value={form.phone}
              onChange={handleChange}
              maxLength="10"
              disabled={loading}
            />

            <p style={{ marginTop: "10px", fontWeight: "700" }}>
              Plan: {isOptionalPlan && selectedOption
                ? selectedOption.title
                : selectedPlan.title}
            </p>

            <p style={{ marginTop: "5px", fontWeight: "700" }}>
              Paying: ₹
              {isOptionalPlan
                ? selectedOption?.price || 0
                : selectedPlan.price}
            </p>

            <div className="payment-buttons">
              <button
                className="ra-plan-contact-btn"
                onClick={handlePayment}
                disabled={loading}
              >
                {loading
                  ? "Processing..."
                  : isOptionalPlan
                  ? selectedOption
                    ? `Pay ₹${selectedOption.price}`
                    : "Select Option"
                  : `Pay ₹${selectedPlan.price}`}
              </button>

              <button
                className="ra-plan-close-btn"
                onClick={handleClose}
                disabled={loading}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Plan;